import apiClient from '../helpers/ApiClient'
import { handleError, authHeader } from '@/helpers/ApiClient';

export const voucherService = {
    getVouchers,
    getVoucher,
    getVoucherRedemptions,
    createVouchers,
    updateVoucher,
    deleteVoucher,
    downloadVouchersPdf
}

function getVouchers() {
    return apiClient.get('/voucher', {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function getVoucher(voucherId) {
    return apiClient.get(`/voucher/${voucherId}`, {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function getVoucherRedemptions(voucherId) {
    return apiClient.get(`/voucher/${voucherId}/redemptions`, {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function createVouchers(voucher) {
    return apiClient.post('/voucher', voucher, {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function updateVoucher(voucherId, voucher) {
    return apiClient.patch(`/voucher/${voucherId}`, voucher, {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function deleteVoucher(voucherId) {
    return apiClient.delete(`/voucher/${voucherId}`, {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function downloadVouchersPdf(voucherIds) {
    return apiClient.post('/voucher/pdf', {voucherIds: voucherIds}, {
            headers: authHeader(),
            responseType: "blob",
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}
